export default __webpack_public_path__ + "static/bts_thumb-9761c4fcac8bfb05cc6123f1e12fb95e.jpg";